export default "__VITE_ASSET__b5afd822__"